export default {
  home: {
    sections: {
      trendingParlays: "Combinés populaires du jour",
    },
    checkout: {
      placeItOn: "Pariez sur",
    },
    matchups: {
      today: "Matchups d'aujourd'hui",
      thisWeek: "Matchups de cette semaine",
      upcoming: "Matchups à venir",
    },
    actions: {
      claimNow: "Profitez-en maintenant",
      showMore: "Afficher plus",
      showLess: "Afficher moins",
    },
    empty: {
      parlayMinGames: "Aucune tendance disponible pour le moment. Minimum de 3 matchs requis.",
    },
    hundredPercentClub: {
      subtitle: "Props qui ont touché dans 100% des matchs",
    },
    advancedTools: {
      subtitles: {
        startingLineups: "Trouvez de la valeur quand les alignements partants changent. Inclus avec",
        injuryImpact: "Voyez comment les blessures influencent les coéquipiers. Inclus avec",
        opponentRank: "Exploitez les matchups défensifs favorables. Inclus avec",
        startingPitchers: "Ciblez les situations contre des lanceurs vulnérables. Inclus avec",
        weatherReport: "Utilisez le vent et la météo à votre avantage. Inclus avec",
      },
    },
    predictionMarkets: {
      status: {
        loading: "Chargement des marchés...",
        loadError: "Impossible de charger les marchés.",
      },
    },
    sidebar: {
      downloadApp: "Téléchargez l'application",
      neverMissTrend: "Ne manquez aucune tendance",
      unlockAnalysis: "Débloquez l'analyse complète",
      unlock: "Débloquer",
      mostBetOn: "Les plus pariés",
      mostSearched: "Les plus recherchés",
      trendingLeagues: "Ligues populaires",
      topOffers: "Le meilleur de {{type}}",
      newsletter: {
        title: "Gardez une longueur d'avance",
        description: "Rejoignez <strong>plus de 30 000 parieurs sportifs</strong> qui reçoivent les analyses et les offres de Linemate par courriel.",
        subscribe: "S'abonner",
        subscribedTitle: "Vous êtes abonné !",
        subscribedBody: "Nous vous enverrons les dernières tendances et offres de Linemate par courriel.",
      },
      improveExperience: "Améliorez votre expérience Linemate",
      getAccess: "OBTENEZ ACCÈS À DES JEUX AVANCÉS ET À DES ANALYSES PLUS POUSSÉES",
    },
  },
};
